import { TimerSyncIcon } from './TimerSyncIcon';

/**
 * author: Colton Wiscombe
 * id 38A07095-B521-4D7C-8021-FD6CEAD49F10
 * name timer-sync
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-sync.svg
 * tags
 * - Date / Time 
 */
export const StopwatchSyncIcon = TimerSyncIcon;
export default StopwatchSyncIcon